import React, { useState } from "react";
import { Upload, X } from "lucide-react";
import { api, assetUrl, formatApiError } from "../../lib/api";
import { btnGhost } from "./uiKit";

export default function ImageUpload({
  value,
  onChange,
  label = "Photo",
  prefix = "img",
  maxSide = 1600,
  quality = 82,
  testId = "image-upload",
}) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const handleFile = async (file) => {
    if (!file) return;
    setBusy(true);
    setErr(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("prefix", prefix);
      fd.append("max_side", String(maxSide));
      fd.append("quality", String(quality));
      const { data } = await api.post("/admin/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col gap-2" data-testid={testId}>
      <span className="text-[10px] font-stats uppercase tracking-widest text-neutral-500">
        {label}
      </span>
      <div className="flex items-center gap-3 flex-wrap">
        {value ? (
          <div className="relative w-24 h-24 border border-neutral-800 bg-neutral-900 overflow-hidden shrink-0">
            <img
              src={assetUrl(value)}
              alt=""
              className="w-full h-full object-cover object-top"
            />
            <button
              type="button"
              onClick={() => onChange(null)}
              className="absolute top-1 right-1 bg-black/70 text-white p-0.5"
              aria-label="Retirer l'image"
              data-testid={`${testId}-remove`}
            >
              <X size={12} />
            </button>
          </div>
        ) : (
          <div className="w-24 h-24 border border-dashed border-neutral-800 bg-neutral-900/50 flex items-center justify-center text-neutral-700 text-[9px] font-stats uppercase tracking-widest shrink-0">
            AUCUN
          </div>
        )}
        <label className={`${btnGhost} cursor-pointer`}>
          <Upload size={14} />
          {busy ? "UPLOAD…" : value ? "Remplacer" : "Uploader"}
          <input
            type="file"
            accept="image/*"
            className="hidden"
            data-testid={`${testId}-input`}
            onChange={(e) => handleFile(e.target.files?.[0])}
            disabled={busy}
          />
        </label>
      </div>
      {err && (
        <p className="text-[11px] text-burkina-red font-stats uppercase tracking-widest">
          {err}
        </p>
      )}
    </div>
  );
}
